module.exports = ElcRuntime.ELCLogger;